// import { ConfigProvider, theme } from "antd";
import React from "react";
import ReactDOM from "react-dom/client";
import { HashRouter } from "react-router-dom";
import App from "./App";
import "./index.scss";
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <HashRouter>
      {/* <ConfigProvider
        locale={frFR}
        // theme={{
        //   algorithm: theme.darkAlgorithm,
        // }}
      >
        <App />
      </ConfigProvider> */}
      <App />
    </HashRouter>
  </React.StrictMode>
);
